// extracted by mini-css-extract-plugin
export var changeIcon = "_6t-4";
export var container = "_6t-0";
export var divider = "_6t-7";
export var externalLinkIcon = "_6t-1";
export var green = "_6t-5";
export var helpCircleIcon = "_6t-3";
export var iconButton = "_6t-2";
export var red = "_6t-6";